import * as React from 'react';

import { JsonQuery } from '../../../../../JsonQuery';
import { Apartments } from '../../../components/advancedFilters/Apartments';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const ApartmentsContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const apartments = new JsonQuery(jsonQuery).getApartments();

  const handleChange = React.useCallback(
    (apartments: boolean | null) => {
      onChange({ action: 'setApartments', arguments: [apartments] });
    },
    [onChange],
  );

  return <Apartments value={apartments} onChange={handleChange} />;
};
